import { getThemeAccentColor } from '@/utils/themeColor';
import { Col, Form, message, Row } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignUpUser } from '../../apis/auth.js';
import { CustomButton, CustomInput } from '../../components';
import { useSpin } from '../../components/SpinContext';

interface SignupFormValues {
  name: string;
  email: string;
  company_name: string;
}

const SignupForm: React.FC = () => {
  const { showSpin, hideSpin } = useSpin();
  const [form] = Form.useForm<SignupFormValues>();
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();

  const onFinish = (values: SignupFormValues) => {
    if (values && Object.keys(values).length > 0) {
      setIsFormValid(true);
      showSpin();
      SignUpUser(values)
        .then((res) => {
          if (res?.data?.data?.is_success) {
            navigate('/verify-email', { state: values });
          } else {
            message.error(res?.data?.data?.message);
          }
        })
        .catch(() => {})
        .finally(() => {
          hideSpin();
          setIsFormValid(false);
        });
    }
  };

  const handleClick = () => {
    navigate('/login');
  };

  const signupBtnColor = getThemeAccentColor();
  return (
    <>
      <Form
        form={form}
        name='signupForm'
        className='signup-form'
        layout='vertical'
        onFinish={onFinish}
        autoComplete='off'
      >
        <Row gutter={[16, 24]} className='auth-title-container'>
          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item
              className='custom-input'
              label='Your name'
              name='name'
              rules={[
                { required: true, message: 'Please enter your name' },
                {
                  type: 'string',
                  min: 3,
                  message: 'Name must be at least 3 characters long',
                },
              ]}
              style={{ marginBottom: '0px' }}
            >
              <CustomInput
                placeholder='First and last'
                textColor='var(--text-secondary)'
                borderRadius='8px'
                placeholderColor='var(--text-secondary)'
                lineHeight='20px'
              />
            </Form.Item>
          </Col>

          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item
              label='Your email'
              name='email'
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Enter Valid Email Only' },
              ]}
              style={{ marginBottom: '0px' }}
            >
              <CustomInput
                placeholder='name@example.com'
                textColor='var(--text-secondary)'
                borderRadius='8px'
                placeholderColor='var(--text-secondary)'
                lineHeight='20px'
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label='Company name'
              name='company_name'
              rules={[
                { required: true, message: 'Please enter your company name' },
                {
                  type: 'string',
                  min: 3,
                  message: 'Company name must be at least 3 characters long',
                },
              ]}
            >
              <CustomInput
                placeholder='Your company’s name'
                textColor='var(--text-secondary)'
                borderRadius='8px'
                placeholderColor='var(--text-secondary)'
                lineHeight='20px'
                width='100%'
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <CustomButton
              text='Get Started'
              block={true}
              height='48px'
              bgColor={signupBtnColor}
              color='#fff'
              borderRadius='8px'
              isFormValid={isFormValid}
              htmlType='submit'
              fontSize='14px'
              fontWeight={500}
              marginTop='8px'
            />
          </Col>
        </Row>
      </Form>

      <Row justify='center' align='middle' style={{ marginTop: '20px' }}>
        <Col>
          <p
            className='auth-signup-footer-text'
            style={{
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
              color: 'var(--text-secondary)',
            }}
          >
            Already have an account?{' '}
            <span onClick={handleClick} style={{ cursor: 'pointer' }}>
              Login
            </span>
          </p>
        </Col>
      </Row>
    </>
  );
};

export default SignupForm;
